import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { business } from 'src/app/shared/services/get-auth-business.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { Validators } from 'src/app/shared/validators';
import Swal from 'sweetalert2';
import { SendMarketingSmsService } from '../../../services/send-marketing-sms.service';

@Component({
  selector: 'app-create-marketing-sms',
  templateUrl: './create-marketing-sms.component.html',
  styleUrls: ['./create-marketing-sms.component.scss'],
})
export class CreateMarketingSmsComponent implements OnInit {
  mobileNumbersArray: Array<string> = [];
  formValidator: FormValidatorService;
  smsForm!: FormGroup;
  isSubmitting: boolean = false;
  messageLength: number;
  businessSignature: string;
  business: business;
  messagesNumber = 1;
  arabic = /[\u0600-\u06FF]/;
  constructor(
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService,
    private sendMarketingSmssService: SendMarketingSmsService,
    private auth: AuthService
  ) {
    this.formValidator = new FormValidatorService();
  }

  async ngOnInit() {
    this.mobileNumbersArray = this.sendMarketingSmssService.getMobilesArray();
    if (this.mobileNumbersArray.length == 0) {
      this.router.navigate(['/seller/reports/sms-marketing']);
    }
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });

    this.business = await this.auth.getBusiness();
    this.businessSignature = this.translate.instant(
      'Sellers.Dashboard.SentByBusiness',
      {
        businessName: this.business.name,
      }
    );
    this.messageLength = this.businessSignature.length;

    this.smsForm = this.formValidator.createForm([
      {
        fieldName: 'Body',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);
    this.smsForm.valueChanges.subscribe((value) => {
      this.messageLength = this.businessSignature.length + value.Body.length;
      if (!this.arabic.test(value.Body)) {
        this.messagesNumber = Math.floor(this.messageLength / 160) + 1;
      } else this.messagesNumber = Math.floor(this.messageLength / 70) + 1;
    });
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  async submit() {
    try {
      this.isSubmitting = true;
      let { isConfirmed } = await this.showSendSmsDisclaimer();
      if (isConfirmed) {
        this.sendMarketingSmssService.setParams({
          mobileNumbersArray: this.mobileNumbersArray,
          message: this.smsForm.get('Body').value,
          messagesNumber: this.messagesNumber,
        });
        await this.sendMarketingSmssService.make();
        await this.showSuccessDisclaimer();
      }
      this.isSubmitting = false;
      this.router.navigate(['/seller/reports/sms-marketing']);
    } catch (error) {
      this.isSubmitting = false;
      if (error.faultyRequest.error.name == 'NotEnoughBalanceException') {
        await this.showNotEnoughBalanceDisclaimer();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Ooops',
          text: 'Something went wrong, please try again',
          timer: 3000,
        });
      }
      await this.router.navigate(['/seller/reports/sms-marketing']);
    }
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        Body: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Body',
            fieldAr: 'المحتوي',
          }),
        },
      };
    });
  }

  async showSendSmsDisclaimer() {
    return await Swal.fire({
      icon: 'info',
      showCloseButton: true,
      title: `${this.translate.instant('Sellers.Products.Disclaimer')}`,
      html: `
      <ul>
        <li>${this.translate.instant(
          'Sellers.Dashboard.SmsMarketingDisclaimer',
          {
            msgsNumber: this.mobileNumbersArray.length,
            amount: this.mobileNumbersArray.length * this.messagesNumber * 0.5,
          }
        )}.
        </li>
        <li>${this.translate.instant(
          'Sellers.Dashboard.SmsMarketingAdminReview'
        )}
        </li>
      </ul>`,
    });
  }

  async showSuccessDisclaimer() {
    Swal.fire({
      icon: 'success',
      title: `${this.translate.instant(
        'Sellers.Dashboard.MarketingSmssSuccess'
      )}`,
      showConfirmButton: true,
      timer: 3000,
    });
  }

  async showNotEnoughBalanceDisclaimer() {
    Swal.fire({
      icon: 'error',
      title: `${this.translate.instant('Sellers.Dashboard.NotEnoughBalance')}`,
      showConfirmButton: true,
      timer: 3000,
    });
  }

  convertControls(name: string) {
    return this.smsForm.get(name) as FormControl;
  }

}
